const fixSnizeListProducts = () => {
    const resultItems = document.querySelectorAll(`.boost-sd__product-item`);
   
    if (resultItems.length) {
        resultItems.forEach(async (resultItem) => {
            const productId = resultItem.getAttribute("data-product-id");
           
            if (productId) {

                const searchProductPrice = resultItem.querySelector(".boost-sd__product-price-wrapper");
                searchProductPrice.setAttribute("bss-b2b-product-id", productId);
                searchProductPrice.setAttribute("bss-b2b-product-price", "");
            }
            const res = await BSS_B2B.storage.productStorage.load();
            if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {

                await BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                    ...res,
                });

            }
        });
    }
    const quickAddDrawer = document.querySelector('.container:has(.boost-sd__filter-product-list) ')
    console.log(quickAddDrawer)
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach( async function(m) {
                if (m.addedNodes.length) {
                    console.log('test')
                  fixSnizeListProducts()
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {


    let counter = 0;
    let selector = ".boost-sd__product-list"
    const interval = setInterval(() => {
        let element = document.querySelector(selector);
        if (element) {
            console.log("Phần tử đã xuất hiện");
            fixSnizeListProducts()
            clearInterval(interval);
        } else {
            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }
        }
    }, 100);

});